import Heading from 'molecules/Heading';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import AccordionItem from 'components/Accordion/component/AccordionItem';
import { AccordionConfigProps } from 'components/Accordion/config';
import { getFaqSchema, isFaqSection } from 'components/Accordion/utils';
import ScrollFadeSection from 'components/Animations/ScrollFadeSection';

import { hasArrayValues } from 'utils/array/arrays';

import type { FC } from 'react';

const Accordion: FC<AccordionConfigProps> = ({
  accordionItems,
  hasFaqSchema,
  eyebrow,
  heading,
  body,
  alignment,
  buttons,
  htmlId = 'accordion-section',
  className,
  isBulletStandard = false,
  ...props
}) => {
  const { sectionProps } = splitSectionProps(props);

  // Emit FAQ schema when the editor enabled it, or when the section reads as an
  // FAQ ("Common Questions" / "FAQ" heading) so flagged pages are covered
  // without a per-page Builder toggle. Name the schema after the heading.
  const shouldEmitFaqSchema = hasFaqSchema || isFaqSection(heading, eyebrow);
  const faqSchema = shouldEmitFaqSchema && hasArrayValues(accordionItems) && getFaqSchema(accordionItems, heading);

  return (
    <>
      {faqSchema && Object.keys(faqSchema).length && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      )}
      <Section {...sectionProps} id={htmlId}>
        <div className="flex flex-col justify-center gap-10 sm:gap-14 lg:gap-16">
          <Heading eyebrow={eyebrow} heading={heading} body={body} alignment={alignment} buttons={buttons} />
          <ScrollFadeSection delay={0.2}>
            <div className="m-auto grid w-full max-w-[905px] gap-4">
              {hasArrayValues(accordionItems) && (
                <AccordionItem
                  accordionItems={accordionItems}
                  className={className}
                  isBulletStandard={isBulletStandard}
                />
              )}
            </div>
          </ScrollFadeSection>
        </div>
      </Section>
    </>
  );
};

export default Accordion;
